import { cva } from 'class-variance-authority'

export const spinnerVariants = cva('animate-spin rounded-full border-solid border-current', {
  variants: {
    variant: {
      default: 'border-2 border-t-transparent',
      dots: 'border-0',
      pulse: 'border-2 border-t-transparent animate-pulse',
      bounce: 'border-0',
    },
    size: {
      sm: 'h-4 w-4',
      default: 'h-6 w-6',
      lg: 'h-8 w-8',
      xl: 'h-12 w-12',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
})
